// ============================================================================
// blobShadow.js — cheap grounding for the whole army: one InstancedMesh of a
// soft radial disc placed under every active unit + Benjen. Replaces real
// shadow maps on grunts (per the low-poly no-shadow rule). One draw call.
// ============================================================================

import * as THREE from 'three';
import { MAX_ENEMIES } from '../core/constants.js';
import { lerp } from '../core/math.js';

function discTexture() {
  const S = 64;
  const c = document.createElement('canvas'); c.width = c.height = S;
  const g = c.getContext('2d');
  const grd = g.createRadialGradient(S / 2, S / 2, 0, S / 2, S / 2, S / 2);
  grd.addColorStop(0, 'rgba(0,0,0,0.7)');
  grd.addColorStop(0.6, 'rgba(0,0,0,0.35)');
  grd.addColorStop(1, 'rgba(0,0,0,0)');
  g.fillStyle = grd; g.fillRect(0, 0, S, S);
  return new THREE.CanvasTexture(c);
}

export class BlobShadows {
  constructor(scene) {
    const geo = new THREE.PlaneGeometry(1, 1).rotateX(-Math.PI / 2);
    const mat = new THREE.MeshBasicMaterial({
      map: discTexture(), transparent: true, depthWrite: false, color: 0x000000,
    });
    this.mesh = new THREE.InstancedMesh(geo, mat, MAX_ENEMIES + 1);
    this.mesh.frustumCulled = false;
    this.mesh.count = 0;
    this.mesh.renderOrder = 1;
    scene.add(this.mesh);
  }

  update(world, alpha) {
    const units = world.units.active;
    let n = 0;
    for (let i = 0; i < units.length; i++) {
      const u = units[i];
      const x = lerp(u.px, u.x, alpha), z = lerp(u.pz, u.z, alpha);
      const s = u.scale * 1.6 * (u.fade > 0 ? 1 : 0);
      _m.makeScale(s, 1, s);
      _m.setPosition(x, 0.04 + u.y * 0.0, z); // shadow stays on the ground under airborne units
      this.mesh.setMatrixAt(n++, _m);
    }
    // player
    const p = world.player;
    const px = lerp(p.px, p.x, alpha), pz = lerp(p.pz, p.z, alpha);
    _m.makeScale(2.0, 1, 2.0);
    _m.setPosition(px, 0.05, pz);
    this.mesh.setMatrixAt(n++, _m);

    this.mesh.count = n;
    this.mesh.instanceMatrix.needsUpdate = true;
  }
}

const _m = new THREE.Matrix4();
